import MeaPage from "../../../components/MeaPage";
import React, { useRef } from "react";
import CandidatesListComponent from "./components/CandidatesListComponent";
import { useParams, useNavigate } from "react-router-dom";
import MeaButton from "../../../components/MeaButton";
import { Menu } from "primereact/menu";
import { useAuthContext } from "../../../hooks/useAuthContext";
import { PERMISSION_TRAINING_REGISTRATION, PERMISSION_TRAINING_TASKS } from "../../../permissions";

const CandidatesListPage = () => {
  //
  const listRef = useRef();
  const importMenuRef = useRef();
  const params = useParams();
  const navigate = useNavigate();
  const { hasPermission } = useAuthContext();
  const schoolId = params.schoolId;
  const trainingId = params.registrationId;
  
  // Permission checks
  const hasCreateRegistrationPermission = hasPermission(PERMISSION_TRAINING_REGISTRATION.CREATE);
  const hasImportRegistrationFromFilePermission = hasPermission(PERMISSION_TRAINING_TASKS.IMPORT_REGISTRATIONS_FROM_EXCEL_FILE);
  const hasImportRegistrationFromTrainingPermission = hasPermission(PERMISSION_TRAINING_TASKS.IMPORT_FROM_TRAINING);
  const hasExportPermission = hasPermission(PERMISSION_TRAINING_TASKS.EXPORT_STUDENTS_TO_EXCEL_FILE);
  
  // Action buttons component
  const ActionButtons = () => (
    <div className="flex gap-2">
      {hasCreateRegistrationPermission && (
        <MeaButton 
          icon="pi pi-user-plus" 
          permission={PERMISSION_TRAINING_REGISTRATION.CREATE} 
          label="Nouveau dossier" 
          onClick={() => {
            navigate("/school/" + schoolId + "/admin/registrations/" + trainingId + "/candidates-new");
          }} 
        />
      )}
      
      {/* Divider */}
      {hasCreateRegistrationPermission && (hasImportRegistrationFromFilePermission || hasImportRegistrationFromTrainingPermission || hasExportPermission) && (
        <div className="w-1px h-2rem bg-gray-300 mx-2"></div>
      )}
      
      {hasImportRegistrationFromFilePermission && hasImportRegistrationFromTrainingPermission && (
        <>
          <Menu 
            model={[
              {
                label: 'Import depuis une autre formation',
                icon: 'pi pi-download',
                command: () => {
                  navigate("/school/" + schoolId + "/admin/registrations/" + trainingId + "/candidates-import-from-training");
                }
              },
              {
                label: 'Import depuis un fichier Excel',
                icon: 'pi pi-file',
                command: () => {
                  navigate("/school/" + schoolId + "/admin/registrations/" + trainingId + "/candidates-import-from-excel-file");
                }
              }
            ]} 
            popup 
            ref={importMenuRef} 
            id="popup_menu_left" 
          />
          <MeaButton 
            icon="pi pi-download" 
            permission={PERMISSION_TRAINING_TASKS.IMPORT_REGISTRATIONS_FROM_TRAINING} 
            label="Importer" 
            outlined
            onClick={(event) => importMenuRef.current.toggle(event)}
          />
        </>
      )}
      
      {hasExportPermission && (
        <MeaButton 
          icon="pi pi-upload" 
          permission={PERMISSION_TRAINING_TASKS.EXPORT_STUDENTS_TO_EXCEL_FILE} 
          label="Exporter" 
          outlined 
          onClick={() => {
            navigate("/school/" + schoolId + "/admin/registrations/" + trainingId + "/export");
          }} 
        />
      )}
    </div>
  );
  
  //
  return (
    <>
      <MeaPage
        //breadcrumb={<BreadCrumb model={[{ label: 'Les inscriptions' }]} home={{ icon: 'pi pi-home', url: '/' }} />}
        title="Gestion des candidats"
        customActions={<ActionButtons />}
      >
        <CandidatesListComponent
          ref={listRef}
          showAddButton={true}
          showExportButton={true}
          showFilterButton={true}
          schoolId={schoolId}
          trainingId={trainingId}
        />
      </MeaPage>
    </>
  );
};
export default CandidatesListPage;
